import { render, staticRenderFns } from "./SliceProfileMenu.vue?vue&type=template&id=2440e384&"
import script from "./SliceProfileMenu.vue?vue&type=script&lang=js&"
export * from "./SliceProfileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports